import { IEstablishment } from "../interfaces/establishment";

export const ACTUAL_ESTABLISHMENT = "ACTUAL_ESTABLISHMENT"

const storage = JSON.parse(sessionStorage.getItem("selectedBranch") || '{"establishment":{}}')

const initialState = storage;

export default function (state = initialState, action: IEstablishment){
    switch(action.type){
        case ACTUAL_ESTABLISHMENT: {
            let selectedBranch = {
                establishment: action.payload
            }

            sessionStorage.setItem("selectedBranch", JSON.stringify(selectedBranch))
            
            return {
                ...state,
                establishment: action.payload
            }
        }
        
        default: return state;
    }
}